// material-ui
import { styled } from "@mui/material/styles"
import { LinearProgressProps } from "@mui/material/LinearProgress"
import { CircularProgress } from "@mui/material"

// loader style
const LoaderCirlceWrapper = styled("div")(({ theme }) => ({
  zIndex: 2001,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}))

// ==============================|| Loader ||============================== //

export interface LoaderProps extends LinearProgressProps {}

const LoaderCircle = ({ width }: { width: string }) => {
  return (
    <LoaderCirlceWrapper>
      <CircularProgress color="secondary" style={{ width, height: width }} />
    </LoaderCirlceWrapper>
  )
}

export default LoaderCircle
